import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ConfigService } from '../services/config.service';

/**
 * Triggers the runtime config load when entering the authenticated area.
 *
 * Attached to the authenticated parent route, so it only runs for logged-in
 * users and the request carries the Bearer token (via the auth interceptor).
 *
 * Fire-and-forget by design: we do NOT await the load, so navigation is never
 * blocked by a slow or failing config API. `s3BaseUrl` is a signal, so icons
 * resolve reactively once config arrives; a failure degrades gracefully
 * (empty base → initials fallback).
 */
export const configResolver: ResolveFn<boolean> = () => {
  inject(ConfigService).load();
  return true;
};
